import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./global.scss";
import "./style.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
